/**
 * Format a number as USD currency with comma separators.
 * Example: formatCurrency(543362.43) => "$543,362.43"
 */
export const formatCurrency = (value: number): string =>
  `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/**
 * Format a disk size in GB as a human-readable string.
 * Example: formatDiskSize(128) => "128GB", formatDiskSize(1024) => "1TB"
 */
export const formatDiskSize = (size: number): string => {
  if (size >= 1024) {
    const tb = size / 1024;
    return `${tb.toFixed(tb % 1 === 0 ? 0 : 1)}TB`;
  }
  return `${size}GB`;
};
